import { createDocument, getAllData } from "apis/customApiHandler";
import Spinner from "components/Spinner";
import { Fragment, useCallback, useEffect, useMemo, useRef, useState } from "react";
import { BiCloudDownload } from "react-icons/bi";
import ReactSelect from "react-select";
import { Input, Select } from "styled";
import { useQuery } from "react-query";
import { TD, TH } from "styled/table";
import exportExcel from "utils/exportExcel";
import Modal from "components/Modal";
import { Button } from "styled";
import getFormattedDate from "utils/helpers";
// import { BarChart } from "@mui/x-charts";
import Chart from "chart.js/auto";
import { CategoryScale } from "chart.js";
import { Bar, Doughnut, getDatasetAtEvent, getElementAtEvent } from "react-chartjs-2";
import { Box } from "@mui/system";
import { getRandomColor } from "../utils/helpers"
import ChartDataLabels from 'chartjs-plugin-datalabels';
import {
  ResponsiveContainer,
  PieChart,
  Pie,
  Cell,
  Legend,
  Label,
  LabelList,
  Sector,
} from 'recharts';
import "./scrollable-chart.css";
import { useSelector } from "react-redux";
import { trackSearchEvent, trackDownloadAndBulkUploadEvents } from "utils/analytics";
import { ANALYTICS_EVENTS } from "utils/analyticsEvents";
import { useLocation } from "react-router-dom";



const Dashboard = () => {
  const [selectedFleets, setSelectedFleets] = useState("all");
  const [selectedHubs, setSelectedHubs] = useState([]);
  const [dateFrom, setDateFrom] = useState("");
  const [dateTo, setDateTo] = useState("");
  const [reportData, setReportData] = useState("");
  const [downloading, setDownloading] = useState(false);
  const [enabled, setEnabled] = useState(false);
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [contractType, setContractType] = useState("");
  const [searchedIsMobility, setSearchedIsMobility] = useState("")
  const [selectedMakes, setSelectedMakes] = useState([]);
  const [summary, setSummary] = useState(null);
  const [fetch, setFetch] = useState(0)
  const [modalData, setModalData] = useState(null)
  const currentUser = useSelector((state) => state.user.currentUser);
  const [isMobility, setIsMobility] = useState( true);
  const [firstLoad,setFirstLoad] = useState(true)
  

  const location = useLocation();
// Use useEffect to trigger refetching whenever isMobility changes
  useEffect(() => {
    // Trigger refetching of the query whenever isMobility changes
    // queryClient.invalidateQueries('customer-fleet');
    refetch();
  }, [isMobility]);


  // console.log(currentUser)
  useEffect(()=>{
    setIsMobility(currentUser?.userRole?.name === "SUPER_ADMIN" ? "" : true)
  }, [currentUser?.userRole])

  const { data: allFleets, isLoading: loadingFleets , refetch } = useQuery(
    [
        "customer-fleet",
        isMobility && isMobility
      ], () =>
    getAllData("/customer-fleet", {
      limit: 3000,
      ...isMobility!=="" && {isMobility: isMobility}
    })
  );
  // const { data: allMakes } = useQuery([`/vehicle-make-master`], () =>
  //   getAllData("/vehicle-make-master", {
  //     limit: 300,
  //     page: 1,
  //   })
  // );

  const getDashboardSummary = async () => {
    setIsLoading(true);
    setSearchedIsMobility(isMobility)
    try{
    //  console.log(allFleets)
    const dt = await createDocument("/dashboard/summary", {
      ...(selectedFleets!=="all" ? {
        fleets: selectedFleets
      }: {fleets: allFleets?.data.map(data => {return data._id}).join(",")}),
      ...(dateFrom && { dateFrom }),
      ...(dateTo && { dateTo }),
      ...(selectedMakes.length && {
        makes: selectedMakes.map((make) => make).join(","),
      }),
      ...(contractType && { contractType }),
    });
    // console.log({dt})
    setSummary(dt)
    }catch(err){
        console.log({err})
    }
    finally{
      setIsLoading(false);
    }
  };

  const getFleetOptions = useCallback(() => {
    if (allFleets && allFleets.data && allFleets.data.length) {
      return [
        {
          label: "All",
          value: "all",
        },
        ...allFleets?.data?.map((fleet) => {
          return {
            value: fleet._id,
            label: fleet.fleetName,
          };
        }),
      ];
    }
  }, [allFleets]);

  // const getMakeOptions = useCallback(() => {
  //   if (allMakes && allMakes.data && allMakes.data.length) {
  //     return [
  //       {
  //         label: "Select All",
  //         value: "all",
  //       },
  //       ...allMakes?.data?.map((mk) => {
  //         return {
  //           value: mk._id,
  //           label: mk.makeName,
  //         };
  //       }),
  //     ];
  //   }
  // }, [allMakes]);

  const fleetTypes = [
    ...currentUser?.userRole?.name === "SUPER_ADMIN" ? [{ label: "All", value: "" }] : [],
    { label: "Mobility", value: true },
    { label: "Fleet", value: false },
  ];
  const contractTypes = [
    { label: "All", value: "" },
    { label: "CPKM", value: "CPKM" },
    { label: "Service Contract", value: "NON CPKM" },
  ];
  
  const customStyles = {
    // For the select it self, not the options of the select
    control: (styles, { isDisabled}) => {
      return {
        ...styles,
        cursor: isDisabled ? 'not-allowed' : 'default',
        // This is an example: backgroundColor: isDisabled ? 'rgba(206, 217, 224, 0.5)' : 'white'
        color: isDisabled ? '#aaa' : 'white'
      }
    },
    // For the options
    option: (styles, { isDisabled}) => {
      // const color = chroma(data.color);
      return {
        ...styles,
        backgroundColor: isDisabled ? 'red' : 'blue',
        color: '#FFF',
        cursor: isDisabled ? 'not-allowed' : 'default',
      };
    },
  };


  const clickSearchBtn = () => {
    const params = {
      fleet_type: isMobility === "" ? "All" : isMobility === true ? "Mobility" : "Fleet",
      fleets: selectedFleets === "all" ? "All" : getFleetOptions()?.find((item) => item.value === selectedFleets)?.label,
      contract_type: contractType,
      from_date: dateFrom,
      to_date: dateTo,
    }
    trackSearchEvent(ANALYTICS_EVENTS.CLICK_SEARCH_BUTTON, "Fleet Operations", location.pathname, params);
  }


  useEffect(() => {
    setFirstLoad(false);
      if (isLoading === false && firstLoad === false) {
        trackSearchEvent(ANALYTICS_EVENTS.SYS_RESULT_LOADED,"Fleet Operations",location.pathname,{})
      }
  }, [isLoading])
  

  // console.log({selectedFleets, loadingFleets, options: getFleetOptions()})

  return (
    <div>
      <div className="w-full px-8 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 lg:grid-cols-7  justify-center items-center gap-4 mb-4 mt-2">
        <label className="w-full py-0 col-span-1">
          Select Fleet Type
          <ReactSelect
            styles={{
              control: (base, state) => ({
                ...base,
                borderColor: "transparent",
                minWidth: "100%",
                "&:hover": {
                  borderColor: "rgb(34 197 94)",
                },
              }),
            }}
            className="shadow-md rounded-md py-1 mb-2"
            options={fleetTypes}
            style={customStyles}
            isOptionDisabled={(option) =>
              option.value === "" && currentUser.userRole.name !== "SUPER_ADMIN"
            }
            value={fleetTypes.find((fleetType) => {
              return fleetType.value === isMobility;
            })}
            onChange={(value) => {
              setIsMobility(value.value);
              setSelectedFleets("all")
            }}
            name="fleetType"
            isMulti={false}
          />
        </label>

        <label className="w-full py-0 col-span-2 md:col-span-2 lg:col-span-2">
          Select Fleets
          <ReactSelect
            styles={{
              control: (base, state) => ({
                ...base,
                borderColor: "transparent",
                minWidth: "100%",
                "&:hover": {
                  borderColor: "rgb(34 197 94)",
                },
              }),
            }}
            className="shadow-md rounded-md py-1 mb-2"
            options={getFleetOptions()}
            value={{
              value: selectedFleets,
              label: getFleetOptions()?.find(
                (fleet) => fleet.value === selectedFleets
              )?.label,
            }}
            onChange={(value) => {
              // const allValues = value?.map((item) => item.value);
              // console.log({value})

              // if (allValues.includes("all")) {
              //   console.log("first");

              //   setSelectedFleets(
              //     allFleets?.data?.map((item) => {
              //       return item._id;
              //     })
              //   );
              // } else {
              setSelectedFleets(value.value);
              // }
            }}
            name="fleets"
            isMulti={false}
          />
        </label>

        <label className="w-full py-0 col-span-1">
          Select Service Type
          <ReactSelect
            styles={{
              control: (base, state) => ({
                ...base,
                borderColor: "transparent",
                minWidth: "100%",
                "&:hover": {
                  borderColor: "rgb(34 197 94)",
                },
              }),
            }}
            className="shadow-md rounded-md py-1 mb-2"
            options={contractTypes}
            value={contractTypes.find((fleetType) => {
              return fleetType.value === contractType;
            })}
            onChange={(value) => {
              setContractType(value.value);
            }}
            name="contractType"
            isMulti={false}
          />
        </label>
        <label className="w-full py-0 col-span-1">
          Start Date
          <Input
            type="date"
            className="w-full shadow-md rounded-md py-2 px-3 mb-2"
            value={dateFrom}
            onChange={(e) => setDateFrom(e.target.value)}
            max={dateTo || undefined}
          />
        </label>
        <label className="w-full py-0 col-span-1">
          End Date
          <Input
            type="date"
            className="w-full shadow-md rounded-md py-2 px-3 mb-2"
            value={dateTo}
            onChange={(e) => setDateTo(e.target.value)}
            min={dateFrom || undefined}
          />
        </label>

        {/* <label className="w-full py-0 col-span-1">
          Select Makes
          <ReactSelect
            styles={{
              control: (base, state) => ({
                ...base,
                borderColor: "transparent",
                minWidth: "100%",
                "&:hover": {
                  borderColor: "rgb(34 197 94)",
                },
              }),
            }}
            className="shadow-md rounded-md py-1 mb-2"
            options={getMakeOptions()}
            value={
              selectedMakes &&
              selectedMakes?.map((make) => {
                return {
                  value: make,
                  label: allMakes?.data?.find((item) => item?._id === make)
                    ?.makeName,
                };
              })
            }
            onChange={(value) => {
              const allValues = value?.map((item) => item.value);

              if (allValues.includes("all")) {
                setSelectedMakes(
                  allMakes?.data?.map((item) => {
                    return item._id;
                  })
                );
              } else {
                let selectedMakesVal = allMakes?.data?.filter((fleet) =>
                  value?.map((item) => item.value)?.includes(fleet._id)
                );

                setSelectedMakes(value.map((make) => make.value));
              }
            }}
            name="fleets"
            isMulti={true}
          />
        </label> */}

        <button
          type="button"
          disabled={(loadingFleets || !getFleetOptions()?.length || !selectedFleets?.length)}
          className={`text-lg items-end align-end bg-green-500 p-2 text-white rounded-lg float-right mt-4 w-24 ${(
            loadingFleets || !getFleetOptions()?.length || !selectedFleets?.length) && "bg-gray-400"
          } col-span-1`}
          bgPrimary
          onClick={() => {
            clickSearchBtn();
            setFetch((st) => st + 1);
            getDashboardSummary();
          }}
        >
          Search
        </button>
      </div>
      {isLoading ? (
        <Spinner />
      ) : (
        summary && (
          <div className="w-full px-8 flex flex-row grid grid-cols-2 md:grid-cols-4 xl:grid-cols-7 justify-center items-center gap-4 mb-4 ">
            <div className="w-full py-3 bg-gray-100 rounded-md text-center QuickSand">
              <div className="font-normal text-black">Total Hubs </div>
              <div className="font-medium text-sky-600 inter">
                {summary.totalHubs}{" "}
              </div>
            </div>
            <div className="w-full py-3 bg-gray-100 rounded-md text-center QuickSand">
              <div className="font-normal text-black">Total Vehicles </div>
              <div className="font-medium text-sky-600 inter">
                {summary.vehiclesCount}{" "}
              </div>
            </div>
            <div className="w-full py-3 bg-gray-100 rounded-md text-center QuickSand">
              <div className="font-normal text-black">Enrolled Vehicles </div>
              <div className="font-medium text-sky-600 inter">
                {summary.enrolledVehiclesCount}{" "}
              </div>
            </div>
            <div className="w-full py-3 bg-gray-100 rounded-md text-center QuickSand">
              <div className="font-normal text-black">Pending Vehicles </div>
              <div className="font-medium text-sky-600 inter">
                {summary.pendingVehiclesCount}{" "}
              </div>
            </div>
            <div className="w-full py-3 bg-gray-100 rounded-md text-center QuickSand">
              <div className="font-normal text-black">Enrolled % </div>
              <div className="font-medium text-sky-600 inter">
                {parseInt(summary.enrolledPercent)}{" "}
              </div>
            </div>
            <div className="w-full py-3 bg-gray-100 rounded-md text-center QuickSand">
              <div className="font-normal text-black">Inspection % </div>
              <div className="font-medium text-sky-600 inter">
                {parseInt(summary.inspectionPercent)}{" "}
              </div>
            </div>
            <div className="w-full py-3 bg-gray-100 rounded-md text-center QuickSand">
              <div className="font-normal text-black">Alignment % </div>
              <div className="font-medium text-sky-600 inter">
                {parseInt(summary.alignmentPercent)}{" "}
              </div>
            </div>
          </div>
        )
      )}
      {fetch ? (
        <div className="w-full grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-4 p-2">
          <div className="col-span-1 flex h-full w-full">
            <VehicleEnrollmentGraph
              selectedFleets={selectedFleets}
              allFleets={allFleets}
              isMobility={searchedIsMobility}
              selectedMakes={selectedMakes}
              contractType={contractType}
              fetch={fetch}
              setModalData={setModalData}
            />
          </div>
          <div className="w-full col-span-1 flex">
            <PendingFitmentGraph
              selectedFleets={selectedFleets}
              allFleets={allFleets}
              selectedMakes={selectedMakes}
              contractType={contractType}
              fetch={fetch}
              setModalData={setModalData}
            />
          </div>
          <div className="w-full col-span-1 flex">
            <MechanicalConditionGraph
              selectedFleets={selectedFleets}
              allFleets={allFleets}
              selectedMakes={selectedMakes}
              contractType={contractType}
              fetch={fetch}
              setModalData={setModalData}
            />
          </div>
          <div className="w-full col-span-1 flex">
            <InspectionChart
              selectedFleets={selectedFleets}
              allFleets={allFleets}
              dateFrom={dateFrom}
              dateTo={dateTo}
              selectedMakes={selectedMakes}
              contractType={contractType}
              fetch={fetch}
              setModalData={setModalData}
            />
          </div>
          <div className="w-full col-span-1 flex">
            <RotationChart
              selectedFleets={selectedFleets}
              allFleets={allFleets}
              dateFrom={dateFrom}
              dateTo={dateTo}
              selectedMakes={selectedMakes}
              contractType={contractType}
              fetch={fetch}
              setModalData={setModalData}
            />
          </div>
          <div className="w-full col-span-1 flex">
            <AlignmentChart
              selectedFleets={selectedFleets}
              allFleets={allFleets}
              dateFrom={dateFrom}
              dateTo={dateTo}
              selectedMakes={selectedMakes}
              contractType={contractType}
              fetch={fetch}
              setModalData={setModalData}
            />
          </div>
        </div>
      ) : (
        <></>
      )}

      {modalData !== null && (
        <Modal
          handleClick={() => setModalData(null)}
          title={modalData.title}
          className="max-w-2xl"
        >
          {/* <h1>This is the modal</h1> */}
          {/* console.log({modalData}) */}
          <h1 className="w-full flex justify-end text-end px-2 my-1">
            <Button
              onClick={() => {
                trackDownloadAndBulkUploadEvents(ANALYTICS_EVENTS.CLICK_DOWNLOAD_BUTTON, "Dashboard", location.pathname, { model_name: modalData.title });
                try {
                  const exportData = modalData.headers
                    ? modalData.data.map((row) =>
                        modalData.headers.reduce((acc, key) => {
                          acc[key] = row[key];
                          return acc;
                        }, {})
                      )
                    : modalData.data;
                  exportExcel(
                    exportData,
                    modalData.title.split(" ").join("_") + "_Data"
                  );
                  trackDownloadAndBulkUploadEvents(ANALYTICS_EVENTS.SYS_DOWNLOAD_SUCCESS, "Dashboard", location.pathname, { model_name: modalData.title });
                } catch (error) {
                  trackDownloadAndBulkUploadEvents(ANALYTICS_EVENTS.SYS_DOWNLOAD_ERROR, "Dashboard", location.pathname, { model_name: modalData.title, errMsg: error?.message });
                }
              }}
              className=" text-blue-500 hover:scale-105 cursor-pointer text-right"
            >
              Download
            </Button>
          </h1>
          <table className="min-w-full divide-y divide-gray-200">
            <thead className="bg-gray-50">
              <tr>
                <TH scope="col">S.N.</TH>
                {modalData.headers
                  ? modalData.headers.map((heading) => {return <TH scope="col"> {heading}</TH>})
                  : Object.keys(modalData.data[0]).map((key) => {
                      return <TH scope="col"> {key}</TH>;
                    })}
              </tr>
            </thead>
            <tbody>
              {modalData?.data.map((item, index) => {
                // console.log(item, modalData)
                return (
                  <tr>
                    <TD>{index + 1}</TD>
                    {modalData.headers?.map((key) => {
                      // console.log(key, item[key])
                      return (
                        <TD
                          className={`${
                            typeof item[key] === "number"
                              ? "text-right w-[80px]"
                              : "text-left"
                          }`}
                        >
                          {" "}
                          {(item[key])}
                        </TD>
                      );
                    })}
                  </tr>
                );
              })}
            </tbody>
          </table>
        </Modal>
      )}
    </div>
  );
};

const VehicleEnrollmentGraph= ({selectedFleets, selectedMakes, contractType, fetch, setModalData, allFleets,isMobility})=>{
  const [data, setData] = useState(null)
  const [cpkmEnrollmentChartData, setcpkmEnrollmentChartData] = useState(null);
  const [isLoading, setIsLoading] = useState(false)
  const [headers, setHeaders] = useState(null)
  const chartRef = useRef();
  const getCPKMEnrollmentStatus = async () => {
    setIsLoading(true);
    try{
    const dt = await createDocument("/dashboard/cpkm-enrollment-status", {
       ...(selectedFleets!=="all" ? {
        fleets: selectedFleets
      }: {fleets: allFleets?.data.map(data => {return data._id}).join(",")}),
      ...(selectedMakes.length && {
        makes: selectedMakes.map((make) => make).join(","),
      }),
      ...(contractType && { contractType }),
    });
    // console.log(dt)
    setcpkmEnrollmentChartData({
      labels: dt.data.map((data) => data.wheelCount + "W"), 
      datasets: [
        {
          label: "Enrolled Vehicles ",
          data: dt.data.map((data) => data.vehicleCount),
          db: dt.data.map((data) => data.vehicles),
          backgroundColor: "#F1A104",
          borderWidth: 1,
          borderRadius: 6,
        }
      ]
    })
    setHeaders(dt.headers)
  }catch(err){
    setcpkmEnrollmentChartData(null)
    }
    setIsLoading(false);
  };

  useMemo(()=>{
    if(fetch) getCPKMEnrollmentStatus()
  }, [fetch])

  // console.log({isMobility})

  return <Box sx={{ p: 2, boxShadow: "4px 4px 8px 1 px rgba(10, 30, 10, .2)", borderRadius: 2, backgroundColor: "#f8fafc", maxHeight: "550px" }} className= "w-full h-full items-center text-center"> {isLoading ?  <Loading></Loading>: cpkmEnrollmentChartData && 
  <ResponsiveContainer width="90%" height={500}>
  <Bar
  data={cpkmEnrollmentChartData}
  ref={chartRef}
  onClick= {(event) => {
    const index = getElementAtEvent(chartRef.current, event)[0].index
    const data = cpkmEnrollmentChartData.datasets[0].db[index]
    setModalData({title: `${isMobility == true? "CPKM" : isMobility == false ? "Fleet" :""} Enrollment Details`, data, headers})
  }}
  options={{
    responsive: true,
    indexAxis: 'y',
    barThickness: 40, // Adjust this value to control the width of the bars
    scales: {
      x: {
          grid: {
              display: true
          },
          ticks: {
              font: {
                  family: 'Inter', // Your font family
                  size: 14,
              },
          },
      },
      y: {
        grid: {
          display: false
        },
          // beginAtZero: true,
          ticks: {
              font: {
                  family: 'Inter', // Your font family
                  size: 14,
              },
              // // Include a dollar sign in the ticks
              // callback: function (value, index, values) {
              //     return '$' + value;
              // },
          },
      }
  }, 
    plugins: {
      datalabels: {
        anchor: 'auto',
        align: 'auto',
        display: true, // Set to 'auto' to display values on bottom of the bars
        color: "black", // Set the color of the values
        font: {
          family: 'Inter', // Your font family
          size: 14,
          weight: 500
        },
      },
      title: {
        display: true,
        text: `${isMobility === true ? "CPKM" : isMobility === false ? "Fleet" :""} Enrollment Status`,
        font: {
          size: 14,
          family: "Inter"
      }
      },
      legend: {
        display: true,
        position: "bottom",
        labels: {
          // This more specific font property overrides the global property
          font: {
              size: 14,
              family: "Inter"
          }
      }
        // position: 'bottom',
      }
    }
  }}
  plugins={[ChartDataLabels]} // Include the datalabels plugin
/>
</ResponsiveContainer>}
</Box> 
}

const PendingFitmentGraph= ({selectedFleets, selectedMakes, contractType, fetch, setModalData, allFleets})=>{
  const [data, setData] = useState(null)
  const [pendingFitmentChartData, setpendingFitmentChartData] = useState(null);
  const [isLoading, setIsLoading] = useState(false)
  const [headers, setHeaders] = useState(null)
  const pendingChartRef = useRef();
  const getPendingFitmentStatus = async () => {
    setIsLoading(true);
    try{
    const dt = await createDocument("/dashboard/pending-fitment-status", {
      ...(selectedFleets !== "all"
        ? {
            fleets: selectedFleets,
          }
        : {
            fleets: allFleets?.data
              .map((data) => {
                return data._id;
              })
              .join(","),
          }),
      ...(selectedMakes.length && {
        makes: selectedMakes.map((make) => make).join(","),
      }),
      ...(contractType && { contractType }),
    });
    // console.log(dt)
    setpendingFitmentChartData({
      labels: dt.data.map((data) => data.wheelCount + "W"), 
      datasets: [
        {
          label: "Pending Vehicles",
          db: dt.data.map((data) => data.vehicles),
          data: dt.data.map((data) => data.vehicleCount),
          backgroundColor: "#00B4D8",
          borderWidth: 1,
          borderRadius: 6,
        }
      ]
    })
    setHeaders(dt.headers)
  }catch(err){
    setpendingFitmentChartData(null)
    }
    setIsLoading(false);
  };

  useMemo(()=>{
    if(fetch) getPendingFitmentStatus()
  }, [fetch])

  return <Box sx={{ p: 2, boxShadow: "4px 4px 8px 1 px rgba(10, 30, 10, .2)", borderRadius: 2, backgroundColor: "#f8fafc", maxHeight: "550px" }} className= "w-full h-full items-center text-center"> {isLoading ?  <Loading></Loading>: pendingFitmentChartData && 
  <ResponsiveContainer width="90%" height={500}>
  <Bar
  data={pendingFitmentChartData}
  ref={pendingChartRef}
  onClick= {(event) => {
    const index = getElementAtEvent(pendingChartRef.current, event)[0].index
    const data = pendingFitmentChartData.datasets[0].db[index]
    setModalData({title: "Pending Fitment Details", data, headers})
  }}
  options={{
    responsive: true,
    indexAxis: 'y',
    barThickness: 40, // Adjust this value to control the width of the bars
    scales: {
      x: {
          grid: {
              display: true
          },
          ticks: {
              font: {
                  family: 'Inter', // Your font family
                  size: 14,
              },
          },
      },
      y: {
        grid: {
          display: false
        },
          ticks: {
              font: {
                  family: 'Inter', // Your font family
                  size: 14,
              },
              // // Include a dollar sign in the ticks
              // callback: function (value, index, values) {
              //     return '$' + value;
              // },
          },
      }
  }, 
    plugins: {
      datalabels: {
        anchor: 'auto',
        align: 'auto',
        display: true, // Set to 'auto' to display values on bottom of the bars
        color: "black", // Set the color of the values
        font: {
          family: 'Inter', // Your font family
          size: 14,
          weight: 500
        },
      },
      title: {
        display: true,
        text: "Pending Fitment Status",
        font: {
          size: 14,
          family: "Inter"
      }
      },
      datalabels: {
        anchor: 'auto',
        align: 'auto',
        display: true, // Set to 'auto' to display values on bottom of the bars
        color: "black", // Set the color of the values
        font: {
          family: 'Inter', // Your font family
          size: 14,
        },
        formatter: (value, context) => {
          // // console.log({context})
          return value ? value : ""
        },

        
      },
      legend: {
        display: true,
        position: "bottom",
        labels: {
          // This more specific font property overrides the global property
          font: {
              size: 14,
              family: "Inter"
          }
      }
        // position: 'bottom',
      }
    }
  }}
  plugins={[ChartDataLabels]} // Include the datalabels plugin
/>
</ResponsiveContainer>}
</Box> 
}

const MechanicalConditionGraph= ({selectedFleets, selectedMakes, contractType, fetch, setModalData, allFleets})=>{
  const [data, setData] = useState(null)
  const [chartData, setchartData] = useState(null);
  const [isLoading, setIsLoading] = useState(false)
  const chartRef = useRef();
  const getMechanicalConditionStatus = async () => {
    setIsLoading(true);
    try{
    const dt = await createDocument("/dashboard/mechanical-condition-status", {
       ...(selectedFleets!=="all" ? {
        fleets: selectedFleets
      }: {fleets: allFleets?.data.map(data => {return data._id}).join(",")}),
      ...(selectedMakes.length && {
        makes: selectedMakes.map((make) => make).join(","),
      }),
      ...(contractType && { contractType }),
    });
    console.log(dt.data)
    const {
      resolvedLessThan10Days,
      raisedLessThan10Days,
      raisedMoreThan10Days,
      resolvedLessThan10DaysData,
      raisedLessThan10DaysData,
      raisedMoreThan10DaysData,
    } = dt.data;
    setchartData({
      labels: ["<10 Days", ">10 Days"],
      datasets: [
          {
              label: "Resolved",
              data: [new Set(resolvedLessThan10DaysData?.map(item => item["Registration Number"])).size], // Assuming 5 issues were resolved in less than 10 days
              db: [resolvedLessThan10DaysData],
              backgroundColor: '#90EE90',
              stack: 'stack0'
          },
          {
              label: "Open",
              data: [new Set(raisedLessThan10DaysData?.map(item => item["Registration Number"])).size], // Assuming 21 issues are open and were raised in less than 10 days,
              db: [raisedLessThan10DaysData],
              backgroundColor: 'orange',
              stack: 'stack0'
          },
          {
              label: "Not Resolved",
              data: [0, new Set(raisedMoreThan10DaysData?.map(item => item["Registration Number"])).size],
              db: [[], raisedMoreThan10DaysData],
              backgroundColor: 'red',
              stack: 'stack1'
          }
      ]
  },)}catch(err){
    setchartData(null)

    }
    setIsLoading(false);
  };

  useMemo(()=>{
    if(fetch) getMechanicalConditionStatus()
  }, [fetch])

  return (
    <Box sx={{ p: 2, boxShadow: "4px 4px 8px 1 px rgba(10, 30, 10, .2)", borderRadius: 2, backgroundColor: "#f8fafc", maxHeight: "550px" }} className= "w-full h-full items-center text-center"> {isLoading ?  <Loading></Loading>: (
        chartData && (
          <div style={{ height: "550px", width: "100%", overflow: 'auto' }}>
            <span className= "font-bold text-[#707171] text-[14px] mt-5 inter">Mechanical Irregularities</span>
          <ResponsiveContainer width="100%" height={500}>
          <Bar
                data={chartData}
              ref={chartRef}
                onClick={(event) => {
                  const datasetIndex = getDatasetAtEvent(chartRef.current, event).slice(-1)[0].datasetIndex
                  const eleIndex = getDatasetAtEvent(chartRef.current, event).slice(-1)[0].index
                  // console.log(datasetIndex, eleIndex)
                  // console.log({index}, getDatasetAtEvent(chartRef.current, event))
                  // const eleIndex = getDatasetAtEvent(chartRef.current, event)[0]?.index
                  const data = chartData.datasets[datasetIndex]?.db[eleIndex]
                  // console.log(eleIndex, data, getElementAtEvent(chartRef.current, event))
                  // console.log(data[0])
                  setModalData({ title: "Open Mechanical Cases", data: data?.map(({_id, raised, ...rest})=> rest), headers: [
                    "Registration Number",
                    "hub",
                    "Issue Type",
                    "Issue By",
                    "Raising Date",
                    "Closed Date",
                    "delay",
                  ] });
                }}
                options={{
                  scales: {
                      x: {
                          stacked: true,
                          font: {
                            size: 14,
                          },
                          grid: {
                            display: false
                        },
                      },
                      y: {
                          stacked: true,
                          beginAtZero: true,
                          font: {
                            size: 14,
                          },
                          grid: {
                              display: false 
                          },
                      }
                  },
                  plugins: {
                    datalabels: {
                      // 'auto' is not a valid anchor/align value, so every label
                      // fell back to the centre of its segment: on a stacked bar
                      // the tiny "Resolved" slice sat right under "Open" and the
                      // two numbers collided. Anchoring each label just above the
                      // top edge of its own segment separates them by the height
                      // of the segment below, and the formatter drops the 0-value
                      // bars that used to leave a stray "0" on the baseline.
                      // (display stays true: 'auto' resolves the old collision by
                      // hiding the *larger* value, which is worse than the bug.)
                      anchor: 'end',
                      align: 'end',
                      offset: 6,
                      clamp: true,
                      display: true,
                      color: "black", // Set the color of the values
                      font: {
                        family: 'Inter', // Your font family
                        size: 12,
                        weight: 600
                      },
                      formatter: (value) => (value ? value : ""),
                    },
                    title: {
                      display: false,
                      text: "Mechanical Irregularities",
                      font: {
                        size: 14,
                        family: "Inter"
                    }
                    },
                      legend: {
                          display: true,
                          position: 'bottom',
                      },
                      position: "bottom",
                    },
                    layout: {
                      padding: {
                        left: 50, // Adjust the left padding as needed
                        right: 50, // Adjust the right padding as needed
                        top: 50, // Adjust the top padding as needed
                        bottom: 50, // Adjust the bottom padding as needed
                      },
                    },
                }}
                plugins={[ChartDataLabels]} // Include the datalabels plugin
              />
            </ResponsiveContainer> 
           </div>
        )
      )}
    </Box>
  ); 
}


const data = [
  { name: 'Category 1', value: 30 },
  { name: 'Category 2', value: 70 },
];

const COLORS = ["#84E32A","#2AE3D7", "#DC59EE", "#FF8D2D"];

const renderActiveShape = (props) => {
  const {
    cx,
    cy,
    midAngle,
    innerRadius,
    outerRadius,
    startAngle,
    endAngle,
    fill,
    payload,
    percent,
    value
  } = props;
  
  return (
    <g>
      <Sector
        cx={cx}
        cy={cy}
        innerRadius={innerRadius}
        outerRadius={outerRadius + 15}
        startAngle={startAngle}
        endAngle={endAngle}
        fill={fill}
      />
    </g>
  );
};

const InspectionChart= ({selectedFleets, selectedMakes, contractType, dateFrom, dateTo, fetch, setModalData, allFleets, ...props})=>{
  const [data, setData] = useState(null)
  const [chartData, setchartData] = useState(null);
  const [isLoading, setIsLoading] = useState(false)
  const [excludeFitment, setExcludeFitment] = useState(false)
  const [headers, setHeaders] = useState(null)
  const [activeIndex, setActiveIndex] = useState(null);

  const onPieEnter = (index, data) => {
    // console.log('onPieClick', index.value, data);
    const dt = chartData.filter((val, index) => index === data);
    // console.log({dt})
    setModalData({title: "Vehicle Inspection Details", data: dt[0].data, headers: headers})
}
  const getData = async () => {
    setIsLoading(true);
    try{
    const dt = await createDocument("/dashboard/inspection", {
       ...(selectedFleets!=="all" ? {
        fleets: selectedFleets
      }: {fleets: allFleets?.data.map(data => {return data._id}).join(",")}),
      ...(dateFrom && { dateFrom }),
      ...(dateTo && { dateTo }),
      ...(selectedMakes.length && {
        makes: selectedMakes.map((make) => make).join(","),
      }),
      ...(contractType && { contractType }),
      excludeFitment,
    });
    // console.log(dt)
    setchartData([
      {name: "1 - 15 days", value: dt.data[0].oneToFifteenDays, data: dt.data[0].oneToFifteenDaysData.map(item => {
        delete item.lastInspectionDate
        return item;
      })},
      {name: "16 - 30 days", value: dt.data[0].sixteenToThirtyDays, data: dt.data[0].sixteenToThirtyDaysData.map(item => {
        delete item.lastInspectionDate
        return item;
      })},
      {name: "31 - 60 days", value: dt.data[0].thirtyOneToSixtyDays, data: dt.data[0].thirtyOneToSixtyDaysData.map(item => {
        delete item.lastInspectionDate
        return item;
      }),},
      {name: "Above 60 days", value: dt.data[0].sixtyOneToNintyDays + dt.data[0].overNinetyDays, data: [...dt.data[0].sixtyOneToNintyDaysData.map(item => {
        delete item.lastInspectionDate
        return item;
      }), ...dt.data[0].overNinetyDaysData.map(item => {
        delete item.lastInspectionDate
        return item;
      })]},
    ]);
    setHeaders(dt.headers)
  }catch(err){
    setchartData(null)

    }
    setIsLoading(false);
  };

  useMemo(()=>{
    if(fetch) getData()
  }, [fetch, excludeFitment])
  
  const RADIAN = Math.PI / 180;
  return <div className= "w-full h-full items-center">
    <div className= "w-full text-left flex gap-2">
    <input name= "fitment" type = "checkbox" classname= "mx-2" value = {excludeFitment} onChange = {(e)=>{setExcludeFitment(e.target.checked)}}></input>
            <label htmlFor = "fitment">
              Exclude Fitment
            </label>

    </div>
    
  <Box sx={{ p: 2, boxShadow: "4px 4px 8px 1 px rgba(10, 30, 10, .2)", borderRadius: 2, backgroundColor: "#f8fafc", maxHeight: "550px" }} className= " items-center text-center justify-center mx-auto"> 
    {isLoading ?  (
      <Loading/>
    ): chartData && chartData.length > 0 ? ( 
  <ResponsiveContainer width="90%" height={500}>
    <div className = "text-gray-500 inter font-bold text-[14px]"> Vehicle Inspection Count</div>
      <PieChart>
        <Pie
          dataKey="value"
          data={chartData}
          cx="50%"
          cy="50%"
          outerRadius="70%"
          innerRadius="30%"
          fill="#8884d8"
          paddingAngle={1}
          label
          onClick={onPieEnter}
        >
          {chartData.map((entry, index) => (
            <Cell key={index} fill={COLORS[index % COLORS.length]} 
             />
          ))}
        </Pie>
        <Legend align="center" verticalAlign="bottom" height={36} margin={5} />
      </PieChart>
    </ResponsiveContainer>
    ) : (
      <div className="text-gray-500 inter font-bold text-[14px]">No data available</div>
    )}    
</Box> 

</div>
}


const RotationChart= ({selectedFleets, selectedMakes, contractType, dateFrom, dateTo, fetch, setModalData, allFleets, ...props})=>{
  const [data, setData] = useState(null)
  const [chartData, setchartData] = useState(null);
  const [headers, setHeaders] = useState(null)
  const [isLoading, setIsLoading] = useState(false)
  const onPieEnter = (index, data) => {
    // console.log("onPieClick", index.value, data);
    const dt = chartData.filter((val, index) => index === data);
    setModalData({ title: "Vehicle Rotation Details", data: dt[0].data, headers: headers });
  };
  const getData = async () => {
    setIsLoading(true);
    try{
    const dt = await createDocument("/dashboard/rotation", {
       ...(selectedFleets!=="all" ? {
        fleets: selectedFleets
      }: {fleets: allFleets?.data.map(data => {return data._id}).join(",")}),
      ...(dateFrom && { dateFrom }),
      ...(dateTo && { dateTo }),
      ...(selectedMakes.length && {
        makes: selectedMakes.map((make) => make).join(","),
      }),
      ...(contractType && { contractType }),
    });
    // console.log(dt)
    if(dt?.data) { setchartData(
      [
        { value: dt.data.zeroTo10, data: dt.data.zeroTo10Vehicles, name: "0-10k KM"},
        { value: dt.data.tenTo20, data: dt.data.tenTo20Vehicles, name: "10-20k KM"},
        { value: dt.data.twentyTo30, data: dt.data.twentyTo30Vehicles, name: "20-30k KM"},
        { value: dt.data.above30, data: dt.data.above30Vehicles, name: "Above 30k KM"},
      ],
    );
  setHeaders(dt.headers)}
  }catch(err){
    setchartData(null)

    }
    setIsLoading(false);
  };

  useMemo(()=>{
    if(fetch) getData()
  }, [fetch])

  const options = {
    responsive: true,
    plugins: {
      legend: {
        display: true,
        // position: 'right',
      },
      title: {
        display: true,
        fontSize: 20, // <--- this is not a managed option since CHART.JS 3
        text: 'Rotation Chart'
      }
    }
  }

  return <div className= "w-full h-full mt-6">
  <Box sx={{ p: 2, boxShadow: "4px 4px 8px 1 px rgba(10, 30, 10, .2)", borderRadius: 2, backgroundColor: "#f8fafc", maxHeight: "550px" }} className= " items-center text-center justify-center mx-auto"> {isLoading ?  <Loading></Loading>: chartData && 
  <ResponsiveContainer width="90%" height={500}>
        <div className = "text-gray-500 inter font-bold text-[14px]"> Vehicle Rotation Count</div>
      <PieChart>
        <Pie
          dataKey="value"
          data={chartData}
          cx="50%"
          cy="50%"
          outerRadius={"70%"}
          innerRadius={"30%"}
          fill="#8884d8"
          paddingAngle={1}
          label
          onClick={onPieEnter}
        >
          {chartData.map((entry, index) => (
            <Cell key={index} fill={COLORS[index % COLORS.length]} />
          ))}
          <LabelList
            dataKey="name"
            position="outside"
            fill="#8884d8"
            content={({ value, x, y, midAngle }) => {
              const radius = 120;
              const xPos = x + radius * Math.cos(-midAngle * (Math.PI / 180));
              const yPos = y + radius * Math.sin(-midAngle * (Math.PI / 180));
              const cos = Math.cos(-midAngle * (Math.PI / 180));
              const textAnchor = cos >= 0 ? 'start' : 'end'

              return value!==0 && (
                <g>
                  <text x={xPos} y={yPos} fill="#333" textAnchor="middle">
                    {value}
                  </text>

                  {/* <path d={`M${mx},${my}L${sx},${sy}L${ex},${ey}`} stroke={fill} fill="none" /> */}

                  <line
                    x1={x + radius * Math.cos(-midAngle * (Math.PI / 180))}
                    y1={y + radius * Math.sin(-midAngle * (Math.PI / 180))}
                    x2={x + (radius + 10) * Math.cos(-midAngle * (Math.PI / 180))}
                    y2={y + (radius + 10) * Math.sin(-midAngle * (Math.PI / 180))}
                    stroke="#8884d8"
                  />
                </g>
              );
            }}
          />
        </Pie>
        <Legend align="center" verticalAlign="bottom" height={36} />
      </PieChart>
    </ResponsiveContainer>
}
</Box> 
</div>
}

const AlignmentChart= ({selectedFleets, selectedMakes, contractType, dateFrom, dateTo, fetch, setModalData, allFleets, ...props})=>{
  const [data, setData] = useState(null)
  const [chartData, setchartData] = useState(null);
  const [isLoading, setIsLoading] = useState(false)
  const [headers, setHeaders] = useState(null)
  const onPieEnter = (index, data) => {
    // console.log("onPieClick", index.value, data);
    const dt = chartData.filter((val, index) => index === data);
    // console.log({ dt });
    setModalData({ title: "Vehicle Alignment Details", data: dt[0].data, headers: headers });
  };

  const getData = async () => {
    setIsLoading(true);
    try{
    const dt = await createDocument("/dashboard/alignment", {
       ...(selectedFleets!=="all" ? {
        fleets: selectedFleets
      }: {fleets: allFleets?.data.map(data => {return data._id}).join(",")}),
      ...(dateFrom && { dateFrom }),
      ...(dateTo && { dateTo }),
      ...(selectedMakes.length && {
        makes: selectedMakes.map((make) => make).join(","),
      }),
      ...(contractType && { contractType }),
    });
    // console.log(dt)
    setchartData(
      [
        { value: dt.data.zeroTo20, data: dt.data.zeroTo20Vehicles, name: "0-20k KM"},
        { value: dt.data.twentyTo40, data: dt.data.twentyTo40Vehicles, name: "20-40k KM"},
        { value: dt.data.fortyTo60, data: dt.data.fortyTo60Vehicles, name: "40-60k KM"},
        { value: dt.data.above60, data: dt.data.above60Vehicles, name: "Above 60k KM"},
      ],
    )
    setHeaders(dt.headers)
  }catch(err){
    setchartData(null)

    }
    setIsLoading(false);
  };

  useMemo(()=>{
    if(fetch) getData()
  }, [fetch])
  const options = {
    responsive: true,
    plugins: {
      legend: {
        display: true,
        // position: 'right',
      },
      title: {
        display: true,
        fontSize: 20, // <--- this is not a managed option since CHART.JS 3
        text: 'Vehicle Alignment Count'
      }
    }
  }

  return <div className= "w-full h-full mt-6">
<Box sx={{ p: 2, boxShadow: "4px 4px 8px 1 px rgba(10, 30, 10, .2)", borderRadius: 2, backgroundColor: "#f8fafc", maxHeight: "550px" }} className= " items-center text-center justify-center mx-auto"> {isLoading ?  <Loading></Loading>: chartData && 
  <ResponsiveContainer width="90%" height={500}>
        <div className = "text-gray-500 inter font-bold text-[14px]"> Vehicle Alignment Count</div>
      <PieChart>
        <Pie
          dataKey="value"
          data={chartData}
          cx="50%"
          cy="50%"
          outerRadius={"70%"}
          innerRadius={"30%"}
          fill="#8884d8"
          paddingAngle={1}
          label
          onClick={onPieEnter}
        >
          {chartData.map((entry, index) => (
            <Cell key={index} fill={COLORS[index % COLORS.length]} />
          ))}
          <LabelList
            dataKey="name"
            position="outside"
            fill="#8884d8"
            content={({ value, x, y, midAngle }) => {
              const radius = 120;
              const xPos = x + radius * Math.cos(-midAngle * (Math.PI / 180));
              const yPos = y + radius * Math.sin(-midAngle * (Math.PI / 180));
              const cos = Math.cos(-midAngle * (Math.PI / 180));
              const textAnchor = cos >= 0 ? 'start' : 'end'

              return value!==0 && (
                <g>
                  <text x={xPos} y={yPos} fill="#333" textAnchor="middle">
                    {value}
                  </text>

                  {/* <path d={`M${mx},${my}L${sx},${sy}L${ex},${ey}`} stroke={fill} fill="none" /> */}

                  <line
                    x1={x + radius * Math.cos(-midAngle * (Math.PI / 180))}
                    y1={y + radius * Math.sin(-midAngle * (Math.PI / 180))}
                    x2={x + (radius + 10) * Math.cos(-midAngle * (Math.PI / 180))}
                    y2={y + (radius + 10) * Math.sin(-midAngle * (Math.PI / 180))}
                    stroke="#8884d8"
                  />
                </g>
              );
            }}
          />
        </Pie>
        <Legend align="center" verticalAlign="bottom" height={36} />
      </PieChart>
    </ResponsiveContainer>
}
</Box> 
</div>
}
const Loading = ()=>{
  return <div>
    <span className= "dot">.</span>
    <span className= "dot">.</span>
    <span className= "dot">.</span>
  </div>
}

export default Dashboard;
